import { cardNode } from "../fragments/cardNode";

export const forYouVerticalVideosQuery = (userId) => {
    return `query {
      personalizedItems(
        algorithmId: "reverse-chron-vertical-videos"
        userId: "${userId}"
        first: 30
      ) {
        nodes {
          ...cardNode
        }
      }
    }
    ${cardNode}
  `;
};
